<template>
  <div class="checkout__place">
    <div class="checkout__place-box">
      <div class="checkout__place-icon">
        <img src="@/assets/img/icons/mark.svg" alt="">
      </div>
      <div class="checkout__place-content">
        <div class="checkout__place-title">
          {{locationStart.city_name_ru}}, <span>{{locationStart.name_ru}}</span>
        </div>
        <div class="checkout__place-rows">
          <div class="checkout__place-row" v-if="car.extras.pick_up_location_fee > 0">
            <div class="checkout__place-row_title">Стоимость подачи</div>
            <div class="checkout__place-row_value">{{car.extras.pick_up_location_fee}} <i class="rouble-sign">₽</i></div>
          </div>
          <div class="checkout__place-row" v-if="car.extras.airport_fee > 0">
            <div class="checkout__place-row_title">Аэропортный сбор</div>
            <div class="checkout__place-row_value">{{car.extras.airport_fee}} <i class="rouble-sign">₽</i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout__place-box">
      <div class="checkout__place-icon">
        <img src="@/assets/img/icons/mark.svg" alt="">
      </div>
      <div class="checkout__place-content">
        <div class="checkout__place-title">
          {{locationEnd.city_name_ru}}, <span>{{locationEnd.name_ru}}</span>
        </div>
        <div class="checkout__place-rows">
          <div class="checkout__place-row" v-if="car.extras.drop_off_location_fee > 0">
            <div class="checkout__place-row_title">Стоимость возврата</div>
            <div class="checkout__place-row_value">{{car.extras.drop_off_location_fee}} <i class="rouble-sign">₽</i></div>
          </div>
          <div class="checkout__place-row" v-if="car.extras.return_fee > 0">
            <div class="checkout__place-row_title">Возврат между станциями</div>
            <div class="checkout__place-row_value">{{car.extras.return_fee}} <i class="rouble-sign">₽</i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout__place-box">
      <div class="checkout__place-icon">
        <img src="@/assets/img/icons/calendar.svg" alt="">
      </div>
      <div class="checkout__place-content">
        <div class="checkout__place-date">
          {{getDate(car.info.date_start.date2)}} <span>{{getHour(car.info.date_start.date2)}}</span> – {{getDate(car.info.date_end.date2)}} <span>{{getHour(car.info.date_end.date2)}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
    name: 'Place',
    props: ['car', 'cars', 'locationStart', 'locationEnd'],
    methods: {
      getDate(date) {
        return moment(date, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY');
      },
      getHour(date) {
        return moment(date, 'DD.MM.YYYY HH:mm:ss').format('HH:mm');
      },
    }
}
</script>
